import script from "./IdentificationScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdentificationScreen.vue?vue&type=script&setup=true&lang=ts"

import "./IdentificationScreen.vue?vue&type=style&index=0&id=1969ea8c&lang=scss"

const __exports__ = script;

export default __exports__